import { useState } from "react";
import { hotList } from "../../../mocks/trendData";

function rankColor(rank: number) {
  if (rank <= 3) return "bg-primary-500 text-white";
  return "bg-background-200 text-foreground-600";
}

export default function HotRank() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <section id="hot" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-fire-fill" aria-hidden="true"></i> 实时更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              今日吃瓜热榜
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              按讨论热度实时排行，点开即可查看事件脉络。
            </p>
          </div>
          <div className="hidden items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-500 sm:flex">
            <i className="ri-time-line" aria-hidden="true"></i>
            <span className="whitespace-nowrap">更新于今日 15:00</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotList.map((item) => {
            const isOpen = expanded === item.rank;
            return (
              <article
                key={item.rank}
                className="group rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5"
              >
                <div className="flex items-start gap-4">
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg font-heading text-sm font-bold md:h-9 md:w-9 ${
                      item.rank <= 3 ? "bg-primary-500 text-white" : rankColor(item.rank)
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                        {item.tag}
                      </span>
                      {item.trend === "up" && (
                        <span className="text-xs font-semibold text-primary-600">
                          <i className="ri-arrow-up-line" aria-hidden="true"></i> 热度飙升
                        </span>
                      )}
                      {item.trend === "down" && (
                        <span className="text-xs font-semibold text-secondary-600">
                          <i className="ri-arrow-down-line" aria-hidden="true"></i> 略有回落
                        </span>
                      )}
                      {item.trend === "flat" && (
                        <span className="text-xs font-semibold text-foreground-400">热度持平</span>
                      )}
                      <span className="ml-auto text-xs text-foreground-400">热度 {item.heat}</span>
                    </div>
                    <button
                      type="button"
                      onClick={() => setExpanded(isOpen ? null : item.rank)}
                      className="mt-2 block w-full cursor-pointer text-left text-sm font-semibold text-foreground-950 transition-colors hover:text-primary-700 md:text-base"
                    >
                      {item.title}
                    </button>
                    {isOpen && (
                      <p className="mt-2 rounded-lg bg-background-100 px-3 py-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                        {item.desc}
                      </p>
                    )}
                    <div className="mt-2 flex items-center justify-between">
                      <button
                        type="button"
                        onClick={() => setExpanded(isOpen ? null : item.rank)}
                        className="inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
                      >
                        {isOpen ? (
                          <>
                            收起详情 <i className="ri-arrow-up-s-line" aria-hidden="true"></i>
                          </>
                        ) : (
                          <>
                            查看详情 <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
                          </>
                        )}
                      </button>
                      <span className="text-xs text-foreground-400">讨论中</span>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}